<template>
    <div class="popular">
        <header class="popular-panel__header h5">{{ title }}</header>
        <swiper
            class="popular-panel__grid"
            :slides-per-view="1.4"
            :space-between="10"
            @swiper="onSwiper"
            @slideChange="onSlideChange">
            <swiper-slide
                class="card"
                v-for="(slide, index) in mobileNavStore.popularTopics"
                :key="`slide-${index}`">
                <a class="card__link" :href="slide.Link.Url" :target="slide.Link.Target">
                    <header class="card__header">{{ slide.Link.Text }}</header>
                    <div v-if="slide.SubText" class="card__body">{{ slide.SubText }}</div>
                </a></swiper-slide
            >
        </swiper>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import type { Ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Swiper as SwiperT } from 'swiper/types';
import { useMobileNavStore } from '../store/mobile-nav.store';

export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        title: {
            type: String,
            required: false,
        },
    },
    setup() {
        const mobileNavStore = useMobileNavStore();

        const activeSlideIndex: Ref<number> = ref(0);
        const nextSlideIndex: Ref<number> = ref(0);
        const prevSlideIndex: Ref<number> = ref(0);
        const activeSlide: Ref<number> = ref(0);

        const onSwiper = (swiper: SwiperT) => {
            activeSlideIndex.value = swiper.realIndex;
            nextSlideIndex.value = activeSlideIndex.value++;
            prevSlideIndex.value = activeSlideIndex.value--;
        };

        const onSlideChange = (e: any) => {
            if (e.slides[e.realIndex] !== activeSlide.value) {
                activeSlideIndex.value = getIndex(e.realIndex);
                nextSlideIndex.value = getIndex(e.realIndex + 1);
                prevSlideIndex.value = getIndex(e.realIndex - 1);
            }
            activeSlide.value = e.slides[e.realIndex];
        };

        const getIndex = (index: number) => {
            if (index < 0) {
                return mobileNavStore.popularTopics.length - 1;
            }
            if (index >= mobileNavStore.popularTopics.length) {
                return 0;
            }
            return index;
        };
        const getItem = (index: number) => {
            let realIndex = index;
            if (index < 0 || index >= mobileNavStore.popularTopics.length) {
                realIndex = getIndex(index);
            }
            return mobileNavStore.popularTopics[realIndex];
        };

        return {
            activeSlideIndex,
            nextSlideIndex,
            prevSlideIndex,
            onSwiper,
            onSlideChange,
            getItem,
            getIndex,
            mobileNavStore,
        };
    },
});
</script>
